'use strict';
const shoppingCartModel = require('./shopping_cart_manager.model').default;

Odigeo.defineWidget('shoppingcartmanager', Odigeo.Widget.extend({
    modelClass: shoppingCartModel,
    // Exposes a interface to access the widget public methods
    execute: function(func, params) {
        switch (func) {
            case 'addProductToShoppingCart':
                this.model.addProductToShoppingCart(params);
                break;
            case 'submitProducts':
                this.model.submitProducts(params);
                break;
            case 'clearShoppingCart':
                this.model.clearShoppingCart();
                break;
            case 'deleteHotelFromCart':
                this.model.deleteHotelFromCart(params);
                break;
            case 'selectFareUpgrade':
                this.model.selectFareUpgrade();
                break;
            case 'deleteFareUpgrade':
                this.model.deleteFareUpgrade();
                break;
            case 'updateSessionAncillaries':
                this.model.updateSessionAncillaries(params);
                break;
        }
        return this;
    },
}));
